import { IFRAME_ID } from 'helpers/constants';

export function reloadIframe(src) {
  const iframe = document.getElementById(IFRAME_ID);
  iframe.src = src || iframe.src;
}



// WEBPACK FOOTER //
// ./src/helpers/reloadIframe.js